module.exports = __webpack_public_path__ + "img/video-off.d9fa8431.svg";